import React from "react";
import { Link } from "react-router-dom";

type Props = {
  open: boolean;
  title: string;
  description: string;
  onClose: () => void;
};

export const UpgradeLimitModal: React.FC<Props> = ({ open, title, description, onClose }) => {
  if (!open) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4"
      role="presentation"
      onClick={onClose}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="upgrade-limit-title"
        className="w-full max-w-md rounded-xl border border-slate-600 bg-slate-800 p-6 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="upgrade-limit-title" className="text-lg font-semibold text-white">
          {title}
        </h2>
        <p className="mt-3 text-sm text-slate-300">{description}</p>
        <div className="mt-6 flex flex-col-reverse gap-2 gap-y-3 sm:flex-row sm:justify-end">
          <button
            type="button"
            className="rounded-lg border border-slate-500 px-4 py-2.5 text-sm font-medium text-slate-200 hover:bg-slate-700/80"
            onClick={onClose}
          >
            Close
          </button>
          <Link
            to="/billing"
            className="rounded-lg bg-emerald-600 px-4 py-2.5 text-center text-sm font-semibold text-white hover:bg-emerald-500"
          >
            Upgrade now
          </Link>
        </div>
      </div>
    </div>
  );
};
